import { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//primereact
import { Button } from "primereact/button";
//components
import Select from "../../../components/input/Select";
import CalendarInput from "../../../components/input/CalendarInput";
//services

//hooks
import { useAppContext } from "../../../context/AppContext";
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
import { getReportReverseInstallment } from "../../../services/Report/getReportReverseInstallment";
import { formatYearDate } from "../../../utils/formatDate";

const FiltersReversalOfInstallments = ({
  setLastData,
  setTable,
  setVisible,
  currentPage,
  setFilter,
  setTotalRecords,
  totalRecords,
  setCurrentPage,
  setFirst,
  setSavedDataTable,
  setRows


}) => {
  const form = useForm();
  const errors = form.formState.errors;
  const [loading, setLoading] = useState(false);


  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const {
    client,
    enterprise,
    isLoadingClients,
    isLoadingEnterprises,
    blocks,
    isLoadingBlocks,
    selectEnterprise,
    selectBlock,
    lands,
    isLoadingLands,
    typePeriodOptions,
    status,
  } = useOptionsSelect();

  const onSubmit = async (data) => {

    if (data.period_start || data.period_end || data.type_period) {
      if (!data.period_start) {
        return toast.warning("Preencha a data de início do período");
      }

      if (!data.period_end) {
        return toast.warning("Preencha a data de término do período");
      }

      if (!data.type_period) {
        return toast.warning("Selecione um tipo de período");
      }
    }
    // console.log(data);
    setLoading(true);
    setLastData(data);

    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );

    if (data.period_start && data.period_end) {
      data.period_start = formatYearDate(data.period_start);
      data.period_end = formatYearDate(data.period_end);
    }

    const cleanedData = {};
    for (let key in data) {
      if (data[key] !== undefined && data[key] !== "") {
        cleanedData[key] = data[key];
      }
    }

    setFilter(cleanedData);

    try {
      const response = await getReportReverseInstallment(data, currentPage);
      const obj = response.data.map((row) => ({
        ...row,
        block: row?.block ? row?.block + " / " + row?.land : "",
      }));
      setTable(obj);
      setSavedDataTable(obj);

      const totalRecords = response.last_page * response.per_page;
      setTotalRecords(totalRecords);
      setCurrentPage(response.current_page);
      setFirst(0);
      setRows(response.per_page);
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setVisible(true);
      setLoading(false);
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
      setLoading(false);
    }
  };







  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="row d-flex mt-4">
        <div className="col-xl-3 col-md-6 mb-3 form-group">
          <Select
            name="enterprise_id"
            label={isLoadingEnterprises ? "Carregando..." : "Empreendimento*"}
            control={form.control}
            disabled={isLoadingEnterprises}
            isRequired={true}
            onChange={(e) => selectEnterprise(e)}
            options={enterprise}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-6 mb-3 form-group">
          <Select
            name="type_period"
            label="Tipo Período"
            control={form.control}
            options={typePeriodOptions}
            errors={errors}
          // isRequired={true}
          />
        </div>
        <div className="col-xl-3 col-md-6 mb-3 form-group">
          <CalendarInput
            name="period_start"
            control={form.control}
            errors={errors}
            label="Data início"
          // isRequired={true}
          />
        </div>
        <div className="col-xl-3 col-md-6 mb-3 form-group">
          <CalendarInput
            name="period_end"
            control={form.control}
            errors={errors}
            label="Data Fim"
          // isRequired={true}
          />
        </div>
        <div className="col-xl-3 col-md-6 mb-3 form-group">
          <Select
            name="client_id"
            control={form.control}
            label={isLoadingClients ? "Carregando..." : "Cliente"}
            disabled={isLoadingClients}
            options={client}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-6 mb-3 form-group">
          <Select
            name="block_id"
            label={isLoadingBlocks ? "Carregando..." : nomenclature[0].value}
            control={form.control}
            disabled={isLoadingBlocks}
            onChange={(e) => selectBlock(e)}
            options={blocks}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-6 mb-3 form-group">
          <Select
            name="land_id"
            label={isLoadingLands ? "Carregando..." : nomenclature[1].value}
            control={form.control}
            errors={errors}
            options={lands ? lands : ""}
            disabled={isLoadingLands}
          />
        </div>
        <div className="col-xl-3 col-md-6 mb-3 form-group">
          <Select
            name="status"
            label="Situação"
            control={form.control}
            options={status}
            errors={errors}
          />
        </div>

        <div className="d-flex justify-content-end my-2">
          <div
            className={`${window.innerWidth <= 992 ? "w-25" : "col-md-1"
              } text-center`}
          >
            <Button
              type="submit"
              icon="fa fa-search"
              aria-label="Search"
              loading={loading}
              className={`rounded-3 py-2.5 w-100`}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default FiltersReversalOfInstallments;
